import { render, staticRenderFns } from "./Popup-center.vue?vue&type=template&id=dac23c74&scoped=true&lang=pug"
import script from "./Popup-center.vue?vue&type=script&lang=js"
export * from "./Popup-center.vue?vue&type=script&lang=js"
import style0 from "./Popup-center.vue?vue&type=style&index=0&id=dac23c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac23c74",
  null
  
)

export default component.exports